import { GAME_SIZES, GAME_WIDTHS as GAME_WIDTHS_CORE } from '@core/js/components/common/GamesView/constants';

export * from '@core/js/components/common/GamesView/constants';

export const GAME_WIDTHS = {
    ...GAME_WIDTHS_CORE,
    [GAME_SIZES.MEDIUM]: {
        ...GAME_WIDTHS_CORE[GAME_SIZES.MEDIUM],
        DESKTOP: 200
    }
};
